// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employeespg-inline-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
}

.employeespg-inline-2 {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.employeespg-inline-3 {
  margin-bottom: 0;
}

.employeespg-inline-4 {
  position: relative;
  flex: 1 1;
  max-width: 300px;
}

.employeespg-inline-5 {
  padding-left: 32px;
  margin-bottom: 0;
}

.employeespg-inline-6 {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

.employeespg-inline-7 {
  margin: 0 auto 16px;
}

.employeespg-inline-8 {
  padding: 0;
  overflow-x: auto;
}

.employeespg-inline-9 {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
}

.employeespg-inline-10 {
  font-family: monospace;
  font-size: 11px;
}

.employeespg-inline-11 {
  font-weight: 600;
}

.employeespg-inline-12 {
  font-size: 11px;
}

.employeespg-inline-13 {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  align-items: center;
}

.employeespg-actions-cell {
  min-width: 300px;
}

.employeespg-act-btn {
  width: 34px;
  height: 34px;
  min-width: 34px;
  padding: 0;
  justify-content: center;
  border-radius: 10px;
}

.employeespg-onboarding-btn {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

.employeespg-inline-14 {
  background: linear-gradient(135deg,#6366f1,#818cf8);
}

.employeespg-inline-15 {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 600;
}

.employeespg-inline-16 {
  font-size: 13px;
  font-weight: 600;
  word-break: break-all;
}

.employeespg-inline-17 {
  display: flex;
  gap: 8px;
  margin-top: 20px;
}

.employeespg-inline-18 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.employeespg-inline-19 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
}

.employeespg-inline-20 {
  font-size: 16px;
  font-weight: 700;
  color: #2563eb;
  margin-bottom: 12px;
}

.employeespg-inline-21 {
  margin-bottom: 8px;
}

.employeespg-inline-22 {
  font-size: 13px;
  color: #334155;
}

.employeespg-inline-23 {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  margin-top: 8px;
}

.employeespg-inline-24 {
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.employeespg-inline-25 {
  font-family: monospace;
  font-size: 16px;
  font-weight: 700;
  color: #4338ca;
  padding: 8px 12px;
  background: #eef2ff;
  border-radius: 6px;
  margin-bottom: 8px;
}

.employeespg-inline-26 {
  font-family: monospace;
  font-size: 16px;
  font-weight: 700;
  color: #d97706;
  padding: 8px 12px;
  background: #fffbeb;
  border-radius: 6px;
}

.employeespg-inline-27 {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 12px;
}

.employeespg-inline-28 {
  width: 100%;
  margin-top: 20px;
}

.employeespg-inline-29 {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  padding: 20px;
}

.employeespg-inline-30 {
  font-size: 14px;
  font-weight: 700;
  color: #4338ca;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.employeespg-inline-31 {
  font-family: monospace;
  font-weight: 700;
  font-size: 15px;
  color: #4338ca;
}

.employeespg-inline-32 {
  font-family: monospace;
  font-weight: 700;
  font-size: 15px;
  color: #d97706;
}

.employeespg-inline-33 {
  font-size: 11px;
  color: #64748b;
  margin-top: 8px;
  font-style: italic;
}

.employeespg-inline-34 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.employeespg-inline-35 {
  background: #f8fafc;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
}

.employeespg-inline-36 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.employeespg-inline-37 {
  font-weight: 700;
  font-size: 13px;
}

.employeespg-inline-38 {
  font-size: 12px;
  color: #64748b;
}

.employeespg-inline-39 {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;
}

.employeespg-inline-40 {
  margin-bottom: 16px;
}

.employeespg-inline-41 {
  font-size: 12px;
  font-weight: 700;
  color: #4338ca;
  margin-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 4px;
}

.employeespg-inline-42 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.employeespg-inline-43 {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
}

.employeespg-inline-44 {
  font-size: 12px;
  font-weight: 500;
}

.employeespg-inline-45 {
  margin-bottom: 16px;
}

.employeespg-inline-46 {
  font-size: 12px;
  font-weight: 700;
  color: #4338ca;
  margin-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 4px;
}

.employeespg-inline-47 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.employeespg-inline-48 {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
}

.employeespg-inline-49 {
  font-size: 12px;
}

.employeespg-inline-50 {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
}

.employeespg-inline-51 {
  font-size: 12px;
}

.employeespg-inline-52 {
  margin-bottom: 16px;
}

.employeespg-inline-53 {
  font-size: 12px;
  font-weight: 700;
  color: #4338ca;
  margin-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 4px;
}

.employeespg-inline-54 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.employeespg-inline-55 {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
}

.employeespg-inline-56 {
  font-size: 12px;
  font-weight: 500;
}

.employeespg-inline-57 {
  font-size: 12px;
  font-weight: 700;
  color: #4338ca;
  margin-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 4px;
}

.employeespg-inline-58 {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #f1f5f9;
}

.employeespg-inline-59 {
  font-weight: 600;
  font-size: 13px;
}

.employeespg-inline-60 {
  font-size: 11px;
  color: #475569;
  margin-top: 2px;
}

.employeespg-inline-61 {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}

.employeespg-inline-62 {
  font-size: 11px;
  color: #64748b;
}

.employeespg-inline-63 {
  font-weight: 600;
  font-size: 11px;
  color: #4338ca;
}

.employeespg-inline-64 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;
}

.employeespg-inline-65 {
  background: #f59e0b;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.employeespg-inline-66 {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.employeespg-inline-67 {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 440px;
  max-width: 90vw;
}

.employeespg-inline-68 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #f59e0b;
}

.employeespg-inline-69 {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 12px;
}

.employeespg-inline-70 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.employeespg-inline-71 {
  accent-color: #f59e0b;
}

.employeespg-inline-72 {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #fed7aa;
  font-size: 12px;
  margin-bottom: 12px;
  box-sizing: border-box;
  resize: vertical;
}

.employeespg-inline-73 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.employeespg-inline-74 {
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
}

.employeespg-dyn-1 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  border: var(--employeespg-1-border);
  background: var(--employeespg-1-background);
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

.employeespg-dyn-2 {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: var(--employeespg-2-cursor);
  background: var(--employeespg-2-background);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/EmployeesPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,2CAA2C;EAC3C,WAAW;AACb","sourcesContent":[".employeespg-inline-1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  gap: 12px;\n}\n\n.employeespg-inline-2 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.employeespg-inline-3 {\n  margin-bottom: 0;\n}\n\n.employeespg-inline-4 {\n  position: relative;\n  flex: 1;\n  max-width: 300px;\n}\n\n.employeespg-inline-5 {\n  padding-left: 32px;\n  margin-bottom: 0;\n}\n\n.employeespg-inline-6 {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.employeespg-inline-7 {\n  margin: 0 auto 16px;\n}\n\n.employeespg-inline-8 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.employeespg-inline-9 {\n  text-align: center;\n  padding: 40px;\n  color: #94a3b8;\n}\n\n.employeespg-inline-10 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.employeespg-inline-11 {\n  font-weight: 600;\n}\n\n.employeespg-inline-12 {\n  font-size: 11px;\n}\n\n.employeespg-inline-13 {\n  display: flex;\n  gap: 6px;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.employeespg-actions-cell {\n  min-width: 300px;\n}\n\n.employeespg-act-btn {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  padding: 0;\n  justify-content: center;\n  border-radius: 10px;\n}\n\n.employeespg-onboarding-btn {\n  border-color: #93c5fd;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.employeespg-inline-14 {\n  background: linear-gradient(135deg,#6366f1,#818cf8);\n}\n\n.employeespg-inline-15 {\n  font-size: 11px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.employeespg-inline-16 {\n  font-size: 13px;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.employeespg-inline-17 {\n  display: flex;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.employeespg-inline-18 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.employeespg-inline-19 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 12px;\n  padding: 20px;\n  text-align: center;\n}\n\n.employeespg-inline-20 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.employeespg-inline-21 {\n  margin-bottom: 8px;\n}\n\n.employeespg-inline-22 {\n  font-size: 13px;\n  color: #334155;\n}\n\n.employeespg-inline-23 {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 8px;\n}\n\n.employeespg-inline-24 {\n  font-size: 11px;\n  color: #64748b;\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.employeespg-inline-25 {\n  font-family: monospace;\n  font-size: 16px;\n  font-weight: 700;\n  color: #4338ca;\n  padding: 8px 12px;\n  background: #eef2ff;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.employeespg-inline-26 {\n  font-family: monospace;\n  font-size: 16px;\n  font-weight: 700;\n  color: #d97706;\n  padding: 8px 12px;\n  background: #fffbeb;\n  border-radius: 6px;\n}\n\n.employeespg-inline-27 {\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 12px;\n}\n\n.employeespg-inline-28 {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.employeespg-inline-29 {\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.employeespg-inline-30 {\n  font-size: 14px;\n  font-weight: 700;\n  color: #4338ca;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.employeespg-inline-31 {\n  font-family: monospace;\n  font-weight: 700;\n  font-size: 15px;\n  color: #4338ca;\n}\n\n.employeespg-inline-32 {\n  font-family: monospace;\n  font-weight: 700;\n  font-size: 15px;\n  color: #d97706;\n}\n\n.employeespg-inline-33 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 8px;\n  font-style: italic;\n}\n\n.employeespg-inline-34 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.employeespg-inline-35 {\n  background: #f8fafc;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.employeespg-inline-36 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.employeespg-inline-37 {\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.employeespg-inline-38 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.employeespg-inline-39 {\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.employeespg-inline-40 {\n  margin-bottom: 16px;\n}\n\n.employeespg-inline-41 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #4338ca;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 4px;\n}\n\n.employeespg-inline-42 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.employeespg-inline-43 {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.employeespg-inline-44 {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.employeespg-inline-45 {\n  margin-bottom: 16px;\n}\n\n.employeespg-inline-46 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #4338ca;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 4px;\n}\n\n.employeespg-inline-47 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.employeespg-inline-48 {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.employeespg-inline-49 {\n  font-size: 12px;\n}\n\n.employeespg-inline-50 {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.employeespg-inline-51 {\n  font-size: 12px;\n}\n\n.employeespg-inline-52 {\n  margin-bottom: 16px;\n}\n\n.employeespg-inline-53 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #4338ca;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 4px;\n}\n\n.employeespg-inline-54 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.employeespg-inline-55 {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.employeespg-inline-56 {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.employeespg-inline-57 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #4338ca;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 4px;\n}\n\n.employeespg-inline-58 {\n  background: #fff;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 8px;\n  border: 1px solid #f1f5f9;\n}\n\n.employeespg-inline-59 {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.employeespg-inline-60 {\n  font-size: 11px;\n  color: #475569;\n  margin-top: 2px;\n}\n\n.employeespg-inline-61 {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 6px;\n}\n\n.employeespg-inline-62 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.employeespg-inline-63 {\n  font-weight: 600;\n  font-size: 11px;\n  color: #4338ca;\n}\n\n.employeespg-inline-64 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  flex-wrap: wrap;\n}\n\n.employeespg-inline-65 {\n  background: #f59e0b;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.employeespg-inline-66 {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.employeespg-inline-67 {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  width: 440px;\n  max-width: 90vw;\n}\n\n.employeespg-inline-68 {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: #f59e0b;\n}\n\n.employeespg-inline-69 {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 12px;\n}\n\n.employeespg-inline-70 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.employeespg-inline-71 {\n  accent-color: #f59e0b;\n}\n\n.employeespg-inline-72 {\n  width: 100%;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #fed7aa;\n  font-size: 12px;\n  margin-bottom: 12px;\n  box-sizing: border-box;\n  resize: vertical;\n}\n\n.employeespg-inline-73 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.employeespg-inline-74 {\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.employeespg-dyn-1 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  border: var(--employeespg-1-border);\n  background: var(--employeespg-1-background);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.employeespg-dyn-2 {\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: var(--employeespg-2-cursor);\n  background: var(--employeespg-2-background);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
